<template>
  <div class="tw-mt-2">
    <WdsText v-if="data.title" :text="data.title" sm class="tw-font-medium" />
    <ComplianceDataFieldRow
      v-for="(row, idx) in rows"
      :key="idx"
      :label="row.label"
      :value="row.value"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import ComplianceDataFieldRow from './ComplianceDataFieldRow.vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const ComplianceDataBankDetailFragment = graphql(`
  fragment ComplianceDataBankDetail on ComplianceDataBankDetail {
    title
    bankDetail {
      id
      beneficiaryName
      bankName
      bankCountry
      iban
      swift
    }
  }
`)

const props = defineProps<{ entry: FragmentType<typeof ComplianceDataBankDetailFragment> }>()
const data = computed(() => useFragment(ComplianceDataBankDetailFragment, props.entry))

// `bankDetail` may resolve to all-null fields when the viewer can't read
// underlying fields (auth gated by BankDetailType). The redacted state is
// expected — the row component already handles null values.
const rows = computed(() => {
  const detail = data.value.bankDetail
  return [
    { label: $t('Country of bank'), value: detail?.bankCountry ?? null },
    { label: $t("Account holder's name"), value: detail?.beneficiaryName ?? null },
    { label: $t('Name of bank'), value: detail?.bankName ?? null },
    { label: $t('IBAN'), value: detail?.iban ?? null },
    { label: $t('SWIFT/BIC'), value: detail?.swift ?? null },
  ]
})
</script>
